import { Partner } from "@/models/partner";
import { Pagination } from "@/models/pagination";
import { IPartner, PartnerState } from "@/types/partner";
import { GeneralMutationTree } from "../generalMutation";

const mutations: GeneralMutationTree<PartnerState, IPartner> = {
  single: (state, single) => {
    state.single = new Partner(single);
  },
  pagination: (state, pagination) => {
    pagination.data = pagination.data.map((item) => new Partner(item));
    state.pagination = new Pagination(pagination);
  },
  clear: (state) => {
    state.single = new Partner();
    state.pagination = new Pagination();
  },
};

export default mutations;
